// Action Types
export const SET_COLLEGIATE_DUNGEON_RACE_DATA = 'SET_COLLEGIATE_DUNGEON_RACE_DATA';
export const SET_COLLEGIATE_DUNGEON_RACE_SUMMARY = 'SET_COLLEGIATE_DUNGEON_RACE_SUMMARY';
export const SET_COLLEGIATE_DUNGEON_RACE_LEADERBOARD = 'SET_COLLEGIATE_DUNGEON_RACE_LEADERBOARD';
export const SET_COLLEGIATE_DUNGEON_RACE_LEADERBOARD_FILTER = 'SET_COLLEGIATE_DUNGEON_RACE_LEADERBOARD_FILTER';
export const SHOW_LOADING_SPINNER = 'SHOW_LOADING_SPINNER';

// Action Creator
const CollegiateDungeonRaceActionCreator = {
  setCollegiateDungeonRaceData(data: any) {
    return {
      type: SET_COLLEGIATE_DUNGEON_RACE_DATA,
      payload: data
    };
  },

  setCollegiateDungeonRaceSummary(data: any) {
    return {
      type: SET_COLLEGIATE_DUNGEON_RACE_SUMMARY,
      payload: data
    };
  },

  setCollegiateDungeonRaceLeaderboard(data: any) {
    return {
      type: SET_COLLEGIATE_DUNGEON_RACE_LEADERBOARD,
      payload: data
    };
  },

  setLeaderboardFilter(data: any) {
    return {
      type: SET_COLLEGIATE_DUNGEON_RACE_LEADERBOARD_FILTER,
      payload: data
    };
  },

  showLoadingSpinner(show: boolean) {
    return {
      type: SHOW_LOADING_SPINNER,
      payload: show
    };
  }
};

export default CollegiateDungeonRaceActionCreator;
